import { createSlice } from '@reduxjs/toolkit';

const viewSlice = createSlice({
    name: 'view',
    initialState: {
        activeView: null
    },
    reducers: {
        setActiveView: (state, action) => {
            state.activeView = action.payload;
        }
    }
});

export const { setActiveView } = viewSlice.actions;

export default viewSlice;